import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Spinner, Container } from "react-bootstrap";
import Logo from "../../../images/Frame 1321317892.png";
import api from "../../../utils/ApiConfig"; // ✅ 'api' fait référence à 'instance'
import { useLocation } from "react-router-dom";
import "../../../../src/style/commande.css";
import { Row, Col } from "react-bootstrap";
import IconAlert from "../../../images/fi_alert-circle.png";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';


const MesLivraisons = () => {
  const [livraisons, setLivraisons] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = JSON.parse(localStorage.getItem("userData"));
    const STATUT_MAP = {
    1: "En cours de livraison",
    4: "En cours de validation",
    2: "Livré",
    3: "En cours de préparation",
    6: "Annulé"
    };
  const fetchLivraisons = async () => {
    try {
      const res = await api.get(`/bo/deliveries?supplierId=${userData.id}`);

      setLivraisons(res.data || []);
    } catch (err) {
      console.error("Erreur récupération livraisons :", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLivraisons();
  }, []);

  const logout = () => {
    // Preserve remembered email before clearing localStorage
    const rememberedEmail = localStorage.getItem("rememberedEmail");

    localStorage.clear();

    // Restore remembered email if it existed
    if (rememberedEmail) {
      localStorage.setItem("rememberedEmail", rememberedEmail);
    }

    window.location.href = "/login";
  };
  const location = useLocation();
  return (
    <div className="PageFournisseur">
      {/* 🔹 Header identique à la page commande */}
      <div className="header row headerSection p-3 border-bottom">
        <div className="col-md-6">
          <img src={Logo} alt="logo marion" width="100px" />
        </div>
        <div className="col-md-6 d-flex justify-content-end align-items-center gap-3">
          <Link
            to="/fournisseur/commande"
            className={`btn btn-custom-menu ${location.pathname === "/fournisseur/commande" ? "active" : ""}`}
          >
            📋 Nouvelle livraison
          </Link>

          <Link
            to="/fournisseur/mes-livraisons"
            className={`btn btn-custom-menu ${location.pathname === "/fournisseur/mes-livraisons" ? "active" : ""}`}
          >
            🛻 Historique des livraisons
          </Link>
          <button onClick={logout} className="btn logoutBtn">
            Se déconnecter
          </button>
        </div>
      </div>

      {/* 🔸 Tableau des livraisons */}
      <Container fluid className="mt-4 px-4">
        <h4 className="mb-3">Historique des livraisons</h4>
        <Alert severity="info" variant="filled">
          <AlertTitle>Information</AlertTitle>
          Seules vos demandes de livraison non facturées sont affichées ici.
        </Alert><br></br>
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <Table striped bordered hover responsive className="w-100">
            <thead className="table-light">
              <tr>
                <th>Date de demande</th>
                <th>Date livraison</th>
                <th>Client</th>
                <th>Adresse de livraison</th>
                <th>Type livraison</th>
                <th>Statut</th>
                <th>Montant HT</th>
              </tr>
            </thead>
            <tbody>
              {livraisons.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    Aucune livraison trouvée
                  </td>
                </tr>
              ) : (
                livraisons.map((item, i) => (
                  <tr key={i}>
                    <td>{item.DateCommande || "—"}</td>
                    <td>{item.DateLivraison || "—"}</td>
                    <td>{item.RaisonSocialClient || "—"}</td>
                    <td>{item.AdresseLivraison || "—"}</td>
                    <td>{item.type_livraison || "—"}</td>
                    <td>{STATUT_MAP[item.StatuCommande] || "—"}</td>
                    <td>{item.tarif_ht ? `${item.tarif_ht} €` : "—"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </Container>
    </div>
  );
};

export default MesLivraisons;
